module.exports = __webpack_public_path__ + "static/assets/48c224b68446dce848ca8a520b0810f5.svg";